import React, { useEffect, useRef, useState } from "react";
import { addMessage, getMessages } from "../../config/MessagesRequest";
import { getUser } from "../../config/UserRequest";
import {format} from 'timeago.js'
import InputEmoji from 'react-input-emoji'

const Chatbox = ({ chat, currentUser,setSendMessage, receiveMessage }) => {
  const [userData, setUserData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const scroll = useRef()

  useEffect(()=>{
    if(receiveMessage !== null && receiveMessage.chatId === chat._id){
      console.log("Data received in Child ChildBox: ", receiveMessage)
      setMessages([...messages, receiveMessage])
    }
  }, [receiveMessage])


  // fetching data for header
  useEffect(() => {
    const userId = chat?.members?.find((id) => id !== currentUser);
    const getUserData = async () => {
      try {
        const { data } = await getUser(userId);
        setUserData(data);
      } catch (error) {
        console.log(error);
      }
    };

    if (chat !== null) getUserData();
  }, [chat, currentUser]);

  // fetch messages
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const { data } = await getMessages(chat._id);
        setMessages(data);
      } catch (error) {
        console.log(error);
      }
    };

    if (chat !== null) fetchMessages();
  }, [chat]);


  const handleChange = (newMessage)=>{
    setNewMessage(newMessage)
  }

  const handleSend = async (e) => {
      e.preventDefault();
      const message = {
        senderId:   currentUser,
        text: newMessage,
        chatId: chat._id,
      }

      // Send Message to database
      try{
        const {data} = await addMessage(message)
        setMessages([...messages, data])
        setNewMessage("")
      }catch(error){
        console.log(error)
      }

      // send Message to socket  server
      const receiverId = chat.members.find((id)=> id !== currentUser)
      setSendMessage({...message, receiverId})

  }

  // Always scroll  to last message
  useEffect(()=> {
    scroll.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages])

  return (
    <>
      <div className="ChatBox-container">
       {chat? (
         <>
         <div className="chat-header">
           <div className="follower">
             <div>
               <img
                 src={
                   userData?.profilePicture
                     ? process.env.REACT_APP_PUBLIC_FOLDER +
                       userData.profilePicture
                     : process.env.REACT_APP_PUBLIC_FOLDER +
                       "defaultProfile.png"
                 }
                 className="followerImage"
                 style={{ width: "50px", height: "50px" }}
                 alt="Profile"
               />
               <div className="name" style={{ fontSize: "0.8rem" }}>
                 <span>
                   {userData?.firstname} {userData?.lastname}
                 </span>
                 <span>Online</span>
               </div>
             </div>
           </div>
           <hr
             style={{
               width: "95%",
               border: "0.1px solid #ececec",
               marginTop: "20px",
             }}
           />
         </div>
         <div className="chat-body">
           {messages.map((message) => (
             <>
               <div ref={scroll}
                 className={
                   message.senderId === currentUser ? "message own" : "message"
                 }
               >
                 <span>{message.text}</span>
                 <span>{format(message.createdAt)}</span>
               </div>
             </>
           ))}
         </div>
         <div className="chat-sender">
           <div>+</div>
           <InputEmoji 
               value = { newMessage }
               onChange = {handleChange}
               required
           />
           <div className="send-button button" onClick={handleSend}>Send</div>
         </div>
       </>
       ):(
        <span className="chatbox-empty-message">
            Tap on a Chat to Start Conversation ...
        </span>
       )}
      </div>
    </>
  );
};

export default Chatbox;
